export const nodeHeader = {
  main: { light: "#005F73", dark: "#111313ff" }
};
